/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserOrganizationRead } from './UserOrganizationRead';
import {
    UserOrganizationReadFromJSON,
    UserOrganizationReadFromJSONTyped,
    UserOrganizationReadToJSON,
    UserOrganizationReadToJSONTyped,
} from './UserOrganizationRead';

/**
 * A user in an organization's user list (`GET /users/all`).
 * 
 * `role_ids` are the user's role rows in this organization, active or not. `membership_active`
 * is the membership status there (set per organization by its administrators); `is_active` is
 * the account status, which only a superadmin changes.
 * @export
 * @interface OrganizationUserRead
 */
export interface OrganizationUserRead {
    /**
     * 
     * @type {string}
     * @memberof OrganizationUserRead
     */
    username: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationUserRead
     */
    email: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationUserRead
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationUserRead
     */
    first_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationUserRead
     */
    last_name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OrganizationUserRead
     */
    grade?: number | null;
    /**
     * 
     * @type {string}
     * @memberof OrganizationUserRead
     */
    avatar_image?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationUserRead
     */
    is_active?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationUserRead
     */
    has_avatar?: boolean;
    /**
     * 
     * @type {string}
     * @memberof OrganizationUserRead
     */
    id: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof OrganizationUserRead
     */
    role_ids?: Array<number>;
    /**
     * The user has an organization where every role row is deactivated (/users/me only; role_ids lists active rows, so this is how the app tells a deactivated member apart from a user who was never added)
     * @type {boolean}
     * @memberof OrganizationUserRead
     */
    has_inactive_memberships?: boolean;
    /**
     * 
     * @type {Array<UserOrganizationRead>}
     * @memberof OrganizationUserRead
     */
    organizations?: Array<UserOrganizationRead> | null;
    /**
     * 
     * @type {Date}
     * @memberof OrganizationUserRead
     */
    created_at?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof OrganizationUserRead
     */
    last_login?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof OrganizationUserRead
     */
    last_active?: Date | null;
    /**
     * Active in this organization: a non-superadmin role row here is active (for a user whose only rows here are superadmin rows, one of those is active)
     * @type {boolean}
     * @memberof OrganizationUserRead
     */
    membership_active: boolean;
}

/**
 * Check if a given object implements the OrganizationUserRead interface.
 */
export function instanceOfOrganizationUserRead(value: object): value is OrganizationUserRead {
    if (!('username' in value) || value['username'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('membership_active' in value) || value['membership_active'] === undefined) return false;
    return true;
}

export function OrganizationUserReadFromJSON(json: any): OrganizationUserRead {
    return OrganizationUserReadFromJSONTyped(json, false);
}

export function OrganizationUserReadFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationUserRead {
    if (json == null) {
        return json;
    }
    return {
        
        'username': json['username'],
        'email': json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'grade': json['grade'] == null ? undefined : json['grade'],
        'avatar_image': json['avatar_image'] == null ? undefined : json['avatar_image'],
        'is_active': json['is_active'] == null ? undefined : json['is_active'],
        'has_avatar': json['has_avatar'] == null ? undefined : json['has_avatar'],
        'id': json['id'],
        'role_ids': json['role_ids'] == null ? undefined : json['role_ids'],
        'has_inactive_memberships': json['has_inactive_memberships'] == null ? undefined : json['has_inactive_memberships'],
        'organizations': json['organizations'] == null ? undefined : ((json['organizations'] as Array<any>).map(UserOrganizationReadFromJSON)),
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'last_login': json['last_login'] == null ? undefined : (new Date(json['last_login'])),
        'last_active': json['last_active'] == null ? undefined : (new Date(json['last_active'])),
        'membership_active': json['membership_active'],
    };
}

export function OrganizationUserReadToJSON(json: any): OrganizationUserRead {
    return OrganizationUserReadToJSONTyped(json, false);
}

export function OrganizationUserReadToJSONTyped(value?: OrganizationUserRead | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'username': value['username'],
        'email': value['email'],
        'phone': value['phone'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'grade': value['grade'],
        'avatar_image': value['avatar_image'],
        'is_active': value['is_active'],
        'has_avatar': value['has_avatar'],
        'id': value['id'],
        'role_ids': value['role_ids'],
        'has_inactive_memberships': value['has_inactive_memberships'],
        'organizations': value['organizations'] == null ? undefined : ((value['organizations'] as Array<any>).map(UserOrganizationReadToJSON)),
        'created_at': value['created_at'] == null ? undefined : ((value['created_at'] as any).toISOString()),
        'last_login': value['last_login'] == null ? undefined : ((value['last_login'] as any).toISOString()),
        'last_active': value['last_active'] == null ? undefined : ((value['last_active'] as any).toISOString()),
        'membership_active': value['membership_active'],
    };
}

